// dc-tabs-auto.js — robust version that doesn't rely on "shopify-block-*" wrappers
(function () {
	function initRoot(root) {
		if (!root || root.dataset.inited === "1" || root.dataset.enabled !== "true") return;

		const bar = root.querySelector(".dc-tabs-auto__bar");
		const container = root.querySelector(".dc-tabs-auto__container");
		if (!bar || !container) return;

		// Collect "blocks" as every direct child element inside the container
		const blockEls = Array.from(container.children).filter((el) => {
			// exclude panels we might have built on a previous pass
			if (el.classList.contains("dc-tabs-auto__panel")) return false;
			// ignore empty shells
			const hasContent = el.childElementCount > 0 || (el.textContent || "").trim().length > 0;
			return hasContent;
		});

		// Find tab markers (any element with [data-tab] inside a top-level block)
		const markers = [];
		blockEls.forEach((blk, idx) => {
			const m = blk.querySelector("[data-tab]");
			if (m) {
				markers.push({
					idx,
					label: (m.getAttribute("data-tab") || m.textContent || "").trim(),
					marker: m,
				});
			}
		});

		if (!markers.length) {
			// No markers -> no tabs
			bar.style.display = "none";
			return;
		}

		// Build panels by grouping blocks from marker i to marker i+1 (exclusive)
		const panels = [];
		markers.forEach((m, i) => {
			const start = m.idx;
			const end = i < markers.length - 1 ? markers[i + 1].idx : blockEls.length;

			const panel = document.createElement("div");
			panel.className = "dc-tabs-auto__panel";
			panel.setAttribute("role", "tabpanel");
			panel.dataset.index = String(i);

			for (let k = start; k < end; k++) {
				if (blockEls[k].parentElement === container) {
					panel.appendChild(blockEls[k]); // move the node into the panel
				}
			}

			// Hide the in-panel heading that carried data-tab (the button will show it)
			const titleEl = panel.querySelector("[data-tab]");
			if (titleEl) titleEl.style.display = "none";

			container.appendChild(panel);
			panels.push(panel);
		});

		// Create tab buttons
		const buttons = markers.map((m, i) => {
			const btn = document.createElement("button");
			btn.type = "button";
			btn.className = "dc-tabs-auto__tab " + m.marker.className;
			btn.setAttribute("role", "tab");
			btn.setAttribute("aria-controls", `panel-${root.dataset.sectionId}-${i}`);
			btn.id = `tab-${root.dataset.sectionId}-${i}`;
			btn.textContent = m.label || `Tab ${i + 1}`;
			btn.addEventListener("click", () => activate(i));
			bar.appendChild(btn);

			panels[i].id = `panel-${root.dataset.sectionId}-${i}`;
			panels[i].setAttribute("aria-labelledby", btn.id);
			return btn;
		});

		function activate(index) {
			buttons.forEach((b, i) => {
				const on = i === index;
				b.classList.toggle("is-active", on);
				b.setAttribute("aria-selected", on ? "true" : "false");
				b.tabIndex = on ? 0 : -1;
			});
			panels.forEach((p, i) => {
				const on = i === index;
				p.classList.toggle("is-active", on);
				if (on) p.removeAttribute("hidden");
				else p.setAttribute("hidden", "");
			});
		}

		// Keyboard navigation on the bar
		bar.addEventListener("keydown", (e) => {
			const current = buttons.findIndex((b) => b === document.activeElement);
			if (current === -1) return;
			let next = null;
			if (e.key === "ArrowRight") next = (current + 1) % buttons.length;
			if (e.key === "ArrowLeft") next = (current - 1 + buttons.length) % buttons.length;
			if (next !== null) {
				e.preventDefault();
				buttons[next].focus();
				buttons[next].click();
			}
		});

		activate(0);
		root.dataset.inited = "1";
	}

	function tryInit(root) {
		// If blocks aren’t there yet, observe until they appear
		const container = root.querySelector(".dc-tabs-auto__container");
		if (!container) return;

		if (container.querySelector("[data-tab]")) {
			initRoot(root);
			return;
		}

		const obs = new MutationObserver(() => {
			if (container.querySelector("[data-tab]")) {
				obs.disconnect();
				initRoot(root);
			}
		});
		obs.observe(container, { childList: true, subtree: true });
	}

	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(".dc-tabs-auto").forEach(tryInit);
	});
})();
